import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import React from "react";
import c_hall_logo from '../../media/chall-logo-big.png';
import c_hall_logo_mobile from '../../media/logo-chall-movil.png';
import cosentino_logo from '../../media/cosentino-logo.png';
import cosentino_logo_mobile from '../../media/logo-cosentino-movil.png';
import product_logo_mobile from '../../media/Logo_Dtt.png';
import product_logo from '../../media/logo-dtt-big.png';
import triangle from "../../media/Asset11@2x_white.png";
import languageJson from "../../common/language/language";
import Countdown from "react-countdown";
import "./Welcome.scss";
import { languages } from "../../common/constants/languages";

export class Welcome extends React.Component<any, any> {
  timer: any;

  constructor(props: any) {
    super(props);
    this.state = { timeNow: new Date(Date.now()) };
    this.timer = null;
  }

  componentWillMount() {
    this.timer = setInterval(() => { this.setState({ timeNow: new Date(Date.now()) }) }, 1000);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    let language = this.props.match.params.lang;
    const isEnglish = language === languages.en;
    const buttonText =
      isEnglish
        ? languageJson.chall.welcome.button_en
        : languageJson.chall.welcome.button_es;
    const welcomeText = languageJson.chall.welcome.welcome_text;
    const productText = languageJson.chall.welcome.product_text;
    const dateText = isEnglish ? "September 7th - CANTORIA" : "7 Septiembre - CANTORIA";
    const accessEventTime = new Date(`${process.env.REACT_APP_ACCESS_EVENT_DATE}`);
    const dateTime = new Date(`${process.env.REACT_APP_DATE}`);
    const eventOpened = accessEventTime < this.state.timeNow && true;
    eventOpened && clearInterval(this.timer);
    return (
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <div className="welcome">
          <div className='header-container'>
            <div className='text_slogan mobile'>
              DESIGN LIVES<br />IN EVERY DETAIL
            </div>
            <div className='text_slogan desktop'>{languageJson.chall.welcome.product_text}</div>
            <img className='logo__cosentino desktop' src={cosentino_logo} alt="Cosentino Logo" />
            <img className='logo__cosentino mobile' src={cosentino_logo_mobile} alt="Cosentino Logo" />
          </div>
          <div className="container">

            <div>
              <img className="logo__c-next desktop" src={c_hall_logo} alt="C-Hall Logo" />
              <img className="logo__c-next mobile" src={c_hall_logo_mobile} alt="C-Hall Logo" />
            </div>

            <div className="countdown mobile">
              <div className="numbers">
                <Countdown date={dateTime} daysInHours={true} />
              </div>
            </div>

            <button
              className={`${eventOpened ? "" : "disabled"}`}
              // className={"disabled"}
              onClick={eventOpened ?
                () => this.goToStreaming(language) :
                () => null}
            // onClick={() => null}
            >
              {buttonText}
            </button>

            <div className="countdown desktop">
              <div className="numbers">
                <Countdown date={dateTime} daysInHours={true} />
              </div>
            </div>


            <img className='logo__product desktop' src={product_logo} alt="DESIGN TO TRANSFORM" />
            <img className='logo__product mobile' src={product_logo_mobile} alt="DESIGN TO TRANSFORM"/>
          </div>
        </div>
      </MsalAuthenticationTemplate>
    );
  }

  goToStreaming = (language: string) => {
    this.props.history.push(`/streaming/${language}`);
  };
}
